module.exports = __webpack_public_path__ + "img/illo_5.0ea95b46.svg";